import micr1 from "../../image/smallproduct/micr1.jpg";
import bra from "../../image/smallproduct/bra.png";
import white from "../../image/smallproduct/white1.5L.png";
import geyser1 from "../../image/smallproduct/geyser1.png";
import pan from "../../image/smallproduct/pan.jpg";
import iron from "../../image/smallproduct/iron.jpg";
import kadai from "../../image/smallproduct/kadai.jpg";
import biryani from "../../image/smallproduct/biryani .jpg";
import kettela from "../../image/smallproduct/kettela.png";
import Mixer from "../../image/smallproduct/Mixer 2.png";
import weta from "../../image/smallproduct/weta.png";
export const smallData = [
  {
    id: 0,
    buyUrl: "https://gshoppi.com/product/6581387da02a3e7d21ac6d07",
    detailsUrl:
      "https://gplusindia.com/luxury-appliances/6/1/dish-washer",
    imageUrl: micr1,
  },
  {
    id: 1,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-DISH-WASHER-16-PLACE-SETTINGS-black-(GM-DW-ULTRAX16)/658bbdfb0d16b48350c46ce4",
    detailsUrl: "https://gplusindia.com/small-appliances/12/1/electric-geyser",
    imageUrl: geyser1,
  },
  {
    id: 2,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-528-L-FRENCH-DOOR-BOTTOM-FREZZER-Refrigerator-(Silver-GM-528W)/65eae981145ae609d59a8577",
    detailsUrl:
      "https://gplusindia.com/small-appliances/4/3/Electric-Rice-Cooker",
    imageUrl: white,
  },
  {
    id: 3,
    buyUrl: "https://gshoppi.com/product/6581475ca02a3e7d21ac6e81",
    detailsUrl:
      "https://gplusindia.com/small-appliances/2/2/gas-stove-3-Burner",
    imageUrl: bra,
  },
  {
    id: 4,
    buyUrl: "https://gshoppi.com/product/67e37e348b2fb7b692bfd8c6",
    detailsUrl: "https://gplusindia.com/small-appliances/3/3/gloria-mixer-grinder",
    imageUrl: Mixer,
  },

  {
    id: 5,
    buyUrl:
      "https://gshoppi.com/product-category/4K-QLED-TV-55%2265%2275%2285%22?id=6777838adfe679a305024798",
    detailsUrl: "https://gplusindia.com/small-appliances/5/1/wet-grinder",
    imageUrl: weta,
  },

  {
    id: 6,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-65L-Premium-Air-Cooler-High-Performance-Cooling-for-Ultimate-Comfort/67e382a68b2fb7b692c06e19",
    detailsUrl: "https://gplusindia.com/small-appliances/7/1/Electric-Kettle",
    imageUrl: kettela,
  },
  {
    id: 7,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-Bloom-3L-Air-Cooler-Efficient-Cooling-with-3L-Capacity/67e2eb978b2fb7b692be80e8",
    detailsUrl: "https://gplusindia.com/small-appliances/11",
    imageUrl: iron,
  },
   {
    id: 8,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-Bloom-3L-Air-Cooler-Efficient-Cooling-with-3L-Capacity/67e2eb978b2fb7b692be80e8",
    detailsUrl: "https://gplusindia.com/small-appliances/9",
    imageUrl: pan,
  },
   {
    id: 9,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-Bloom-3L-Air-Cooler-Efficient-Cooling-with-3L-Capacity/67e2eb978b2fb7b692be80e8",
    detailsUrl: "https://gplusindia.com/small-appliances/8/1/Kadai",
    imageUrl: kadai,
  },
   {
    id: 10,
    buyUrl:
      "https://gshoppi.com/product/G-Plus-Bloom-3L-Air-Cooler-Efficient-Cooling-with-3L-Capacity/67e2eb978b2fb7b692be80e8",
    detailsUrl: "https://gplusindia.com/luxury-appliances/7/0/air-cooler",
    imageUrl: biryani,
  },
  // {
  //     id: 7,
  //     url: "https://gshoppi.com/product/GPLUS-QLED-214-Cm-(85-Inches)-Ultra-HD-4K/65d9baf529cf4480e2ffdabc",
  //     imageUrl: cooler1
  // },
];
